import { AccessibilityContext } from '@/contexts/accessibility.context'
import { useContext } from 'react'

export const useAccessibility = () => {
  const context = useContext(AccessibilityContext)
  if (!context) throw new Error('useAccessibility must be used within an AccessibilityProvider')
  return context
}
